interface SpotlightStyles {
  width: string;
  height: string;
}

interface SpotlightStyleMap {
  [key: string]: SpotlightStyles;
}

const spotlightStyles: SpotlightStyleMap = {
  '.walkthrough-required-info': {
    width: '203px',
    height: '44px'
  },
  '.walkthrough-optional-info': {
    width: '203px',
    height: '173px'
  },
  '.walkthrough-calculate': {
    width: '350px',
    height: '91px'
  }
};

const appliedStepTargets = new Set<string>();

export const applySpotlightStyles = (stepTarget: string): void => {
  if (appliedStepTargets.has(stepTarget)) {
    return;
  }

  if (spotlightStyles[stepTarget]) {
    const spotlightElement = (document.querySelector(
      '[data-testid="spotlight"]'
    ) || document.querySelector('.react-joyride__spotlight')) as HTMLElement;

    if (spotlightElement) {
      const targetElement = document.querySelector(stepTarget) as HTMLElement;
      let top = '';
      let left = '';

      if (stepTarget === '.walkthrough-calculate') {
        top = targetElement.getBoundingClientRect().top - 10 + 'px';
        left = targetElement.getBoundingClientRect().left - 10 + 'px';
      } else {
        top = targetElement.getBoundingClientRect().top + 'px';
        left = targetElement.getBoundingClientRect().left + 'px';
      }
      const styles = {
        ...spotlightStyles[stepTarget],
        top,
        left
      };
      Object.assign(spotlightElement.style, styles);

      appliedStepTargets.add(stepTarget);
    }
  }
};
